const styles = theme => ({
  rootHover: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '40px',
    backgroundColor: '#E3F3FF',
    border: '1px dashed #015FFB',
    borderRadius: '8px',
    gap: 4,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '40px',
    backgroundColor: '#F8FAFC',
    border: '1px dashed #919EAB52',
    borderRadius: '8px',
    gap: 4,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  iconHover: {
    color: '#015FFB',
    fontSize: '32px',
  },
  icon: {
    color: '#919EAB',
    fontSize: '32px',
  },
})
export default styles
